import React, { useState } from "react";
import { Helmet } from "react-helmet";

import "../../assets/css/css_reset_nerdweb.css";
import "../../assets/css/css_header.css";
import "../../assets/css/css_content.css";
import "../../assets/css/css_footer.css";
import "../../assets/css/css_content_carousel.css";

import Logo from "../../assets/hotsite/js_studio_de_danca_logo_txt.svg";
import LogoFooter from "../../assets/hotsite/logo_jsstudio_de_danca.png";

function FAQSection() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };
  const faqs = [
    {
      question: "Quando será a apresentação?",
      answer: (
        <p>
          A 5ª MOSTRA ocorrerá dia <b>11 de dezembro de 2024</b>, com abertura
          do teatro às 19h00 e início da Mostra às 20h00.
        </p>
      ),
    },
    {
      question: "Quais são as opções de ingressos disponíveis?",
      answer: (
        <>
          <p>Temos três categorias de ingressos:</p>
          <p>
            • <b>Promocional Antecipado por R$50,00</b> disponível até
            05/11/2024
          </p>
          <p>
            • <b>Meia-Entrada por R$60,00</b> disponíveis de 06/12/2024 até o
            dia do evento.
          </p>
          <p>
            • <b>Inteira por R$120,00</b> disponíveis de 06/12/2024 até o dia do
            evento.
          </p>
        </>
      ),
    },
    {
      question: "Até quando posso comprar o ingresso promocional?",
      answer: (
        <p>
          Os ingressos promocionais podem ser adquiridos até o dia{" "}
          <b>30 de novembro de 2024.</b>
        </p>
      ),
    },
    {
      question: "O que é necessário para comprar a meia-entrada?",
      answer: (
        <p>
          A meia-entrada está disponível para estudantes, idosos, professores e
          portadores de necessidades especiais. É necessário apresentar a
          documentação válida que comprove a condição na entrada do evento.
        </p>
      ),
    },
    {
      question: "Como posso comprar os ingressos?",
      answer: (
        <p>
          Os ingressos podem ser adquiridos online através do nosso site. Clique
          em{" "}
          <a
            href="https://app.beeventz.com.br"
            title="Comprar Ingressos"
          >
            "Comprar Ingresso"
          </a>{" "}
          na página principal para ser direcionado à plataforma de vendas.
        </p>
      ),
    },
    {
      question: "Os lugares no teatro são marcados?",
      answer: (
        <p>
          <b>Não, os lugares não são marcados</b>. Isso oferece a você a
          flexibilidade de escolher o local que preferir no momento da sua
          chegada. Sugerimos chegar cedo para garantir os melhores lugares
          disponíveis e desfrutar de uma visão perfeita da nossa emocionante 5ª
          Mostra do JS Studio de Dança. Venha preparado para um espetáculo
          inesquecível!
        </p>
      ),
    },
    {
      question: "Onde ocorrerá o evento e qual o endereço?",
      answer: (
        <p>
          O evento será realizado no Teatro Positivo, localizado na Rua Prof.
          Pedro Viriato Parigot de Souza, 5300, Campo Comprido, Curitiba-PR.{" "}
          <a
            href="https://maps.app.goo.gl/EwA19Uj9x4FpTV3b8"
            title="Mapa de como chegar no Teatro Positivo"
            target="_blank"
            rel="noreferrer"
          >
            (Como chegar)
          </a>
        </p>
      ),
    },
    {
      question: "Pode filmar e fotografar para uso pessoal?",
      answer: (
        <>
          <p>
            <b>É liberado gravar e fotografar para uso pessoal</b> sem utilizar
            flash. Respeite os demais espectadores e não obstrua a visão de
            ninguém durante as gravações ou fotografias.
          </p>
          <p>
            Porém, é proibido filmar ou fotografar para uso comercial sem
            autorização prévia da organização do evento.
          </p>
        </>
      ),
    },
    {
      question: "Há estacionamento disponível no local?",
      answer: (
        <p>
          Sim, o Teatro Positivo possui estacionamento com capacidade para
          acomodar um grande número de veículos. O serviço é pago à parte.
        </p>
      ),
    },
    {
      question: "Posso comprar ingressos no local no dia do evento?",
      answer: (
        <p>
          Sim, caso ainda haja ingressos disponíveis, você poderá adquiri-los
          on-line em nosso site ou com a nossa equipe diretamente no Teatro a
          partir das 18:00.
        </p>
      ),
    },
    {
      question:
        "Como posso entrar em contato com o organizador em caso de dúvidas adicionais?",
      answer: (
        <p>
          Você pode entrar em contato conosco através do WhatsApp{" "}
          <a
            href="https://api.whatsapp.com/send?phone=5541992464090"
            title="Enviar mensagem no WhatsApp da JS Studio"
          >
            +55 (41) 99246-4090
          </a>{" "}
          ou pelo e-mail contato@jsstudiodedanca.com.br.
        </p>
      ),
    },
  ];

  // Estado para controlar quais itens estão abertos
  const [activeIndices, setActiveIndices] = useState([0]); // Apenas o primeiro item aberto por padrão

  // Função para alternar o estado de um item
  const toggleAccordion = (index) => {
    if (activeIndices.includes(index)) {
      // Fecha o item se estiver aberto
      setActiveIndices(activeIndices.filter((i) => i !== index));
    } else {
      setActiveIndices([index]);
    }
  };

  return (
    <div className="site">
      <Helmet>
        <title>5ª Mostra JS Studio de Dança</title>

        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta
          name="description"
          content="Ideias Promissoras, Projetos Acelerados, Resultados Reais"
        />
        <meta
          name="keywords"
          content="palavra chave, palavra chave, palavra chave, palavra chave, palavra chave, palavra chave, palavra chave"
        />
        <meta name="REVISIT-AFTER" content="1 DAYS" />
        <meta name="dcterms.audience" content="GLOBAL" />
        <meta name="AUTHOR" content="Cowmeia" />
        <meta name="dcterms.rightsHolder" content="Copyright (c) Nerdweb" />
        <meta name="dc.language" content="pt-br" />
        <meta name="RATING" content="GENERAL" />
        <meta name="Robots" content="INDEX,FOLLOW" />
        <meta name="format-detection" content="telephone=no" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-scale=1"
        />
        <meta name="SKYPE_TOOLBAR" content="SKYPE_TOOLBAR_PARSER_COMPATIBLE" />

        {/* FACEBOOK */}
        <meta property="og:site_name" content="JS Studio de Dança" />
        <meta property="og:title" content="JS Studio de Dança" />
        <meta property="og:description" content="DESCRICAO DO SITE" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.jsstudiodedanca.com.br/" />
        <meta
          property="og:image"
          content="https://www.jsstudiodedanca.com.br/js-studio-facebook.jpg"
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Google Fonts */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
          rel="stylesheet"
        />

        {/* Font Awesome */}
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v6.4.0/css/all.css"
        />

        {/* Favicon */}
        <link rel="shortcut icon" type="image/x-icon" href="favicon.ico" />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="favicon_32x32.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="favicon_180x180.ico"
        />
      </Helmet>

      {/* HEADER */}
      <header id="header" className="header-bg-full">
        <div className="bar-header">
          <div className="bar-center-header">
            <div className="menu">
              <ul>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=5541992464090"
                    title="Enviar mensagem no WhatsApp da JS Studio"
                  >
                    <i className="fa-brands fa-whatsapp"></i> +55 (41)
                    99246-4090
                  </a>
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=5541992464090"
                    title="Fale Conosco"
                  >
                    FALE CONOSCO
                  </a>
                </li>
                <li>
                  <a
                    href="https://app.beeventz.com.br"
                    title="Sistema de Eventos JS Studio de Dança"
                  >
                    MINHA CONTA
                  </a>
                </li>
              </ul>
            </div>
            <div className="redes-sociais">
              <ul>
                <li>
                  <a
                    href="https://www.instagram.com/jsstudiodedanca/"
                    title="Instagram JS Studio de Dança"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@jsstudiodedanca"
                    title="Tik Tok JS Studio de Dança"
                  >
                    <i className="fa-brands fa-tiktok"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/JSStudiodeDanca/"
                    title="Facebook JS Studio de Dança"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UC9pcKChidSY2reUlzG38f7A?view_as=subscriber"
                    title=""
                  >
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/jsstudiodedanca"
                    title="Linkedin JS Studio de Dança"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="center-header">
          {/* LOGO */}
          <div className="logo arrow-topo" data-href="#header">
            <a href="index.html">
              <img className="logo-full" src={Logo} alt="JS Studio de Dança" />
            </a>
          </div>

          <div className="box-nav">
            <div className="container">
              <div
                id="trigger-overlay"
                className="menu-mobile"
                onClick={handleMenuOpen}
              >
                <i className="fas fa-bars"></i>
              </div>
            </div>
            <nav className="nav-web">
              <ul>
                <li>
                  <a
                    className="arrow-topo"
                    data-href="#header"
                    href="/perguntas-frequentes/"
                    title=""
                  >
                    HOME
                  </a>
                </li>
                <li>
                  <a
                    href="#link-valores"
                    title="Valores dos Ingressos para Mostra JS Studio"
                  >
                    VALORES
                  </a>
                </li>
                <li>
                  <a href="#link-infos" title="Informações Sobre o Evento">
                    EVENTO
                  </a>
                </li>
                <li>
                  <a href="#link-local" title="Endereço do Teatro Positivo">
                    LOCAL
                  </a>
                </li>
              </ul>
            </nav>
            <div className="nav-sites">
              <ul>
                <li>
                  <a
                    href="https://app.beeventz.com.br"
                    title="Comprar Ingresso"
                  >
                    COMPRAR INGRESSO
                  </a>
                </li>
              </ul>
            </div>

            <div
              className={`overlay overlay-contentpush ${
                menuOpen ? "open" : ""
              }`}
            >
              <button
                type="button"
                className="overlay-close"
                onClick={handleMenuClose}
              >
                Close
              </button>
              <nav className="nav-mobile">
                <ul>
                  <li>
                    <a
                      className="arrow-topo"
                      data-href="#header"
                      href="/perguntas-frequentes/"
                      title=""
                      onClick={handleMenuClose}
                    >
                      HOME
                    </a>
                  </li>
                  <li>
                    <a
                      href="#link-valores"
                      title="Valores dos Ingressos para Mostra JS Studio"
                      onClick={handleMenuClose}
                    >
                      VALORES
                    </a>
                  </li>
                  <li>
                    <a
                      href="#link-infos"
                      title="Informações Sobre o Evento"
                      onClick={handleMenuClose}
                    >
                      EVENTO
                    </a>
                  </li>
                  <li>
                    <a
                      href="#link-local"
                      title="Endereço do Teatro Positivo"
                      onClick={handleMenuClose}
                    >
                      LOCAL
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://api.whatsapp.com/send?phone=5541992464090"
                      title="Fale Conosco"
                      onClick={handleMenuClose}
                    >
                      FALE CONOSCO
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://app.beeventz.com.br"
                      title="Sistema de Eventos JS Studio de Dança"
                      onClick={handleMenuClose}
                    >
                      MINHA CONTA
                    </a>
                  </li>
                  <li className="cta-menu">
                    <a
                      href="https://app.beeventz.com.br"
                      title="Comprar Ingresso"
                    >
                      COMPRAR INGRESSO
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <section className="faq-bloco-01">
        <div className="center-content">
          <h2>DÚVIDAS FREQUENTES</h2>
          <p className="sub-titulo">
            Aqui, responderemos às perguntas mais comuns para garantir que você
            esteja totalmente preparado para o grande dia!
          </p>

          <div className="accordion-menu">
            <ul>
              {faqs.map((faq, index) => (
                <li
                  key={index}
                  className={activeIndices.includes(index) ? "active" : ""}
                >
                  <div
                    className="accordion-header"
                    onClick={() => toggleAccordion(index)}
                  >
                    <i className="arrow"></i>
                    <h3>
                      <b>{String(index + 1).padStart(2, "0")}.</b>{" "}
                      {faq.question}
                    </h3>
                  </div>
                  {activeIndices.includes(index) && (
                    <div className="accordion-content">{faq.answer}</div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="center-footer">
          {/* LOGO */}
          <div className="logo arrow-topo" data-href="#header">
            <a href="index.html">
              <img src={LogoFooter} alt="JS Studio de Dança" />
            </a>
          </div>

          <div className="box-infos">
            <div className="informacoes">
              <ul>
                <li>
                  <h4>ATENDIMENTO</h4>
                  <p>
                    <a
                      href="https://api.whatsapp.com/send?phone=5541992464090"
                      title=""
                    >
                      <i className="fa-brands fa-whatsapp"></i> +55 (41)
                      99246-4090
                    </a>
                  </p>
                  <p>
                    <i className="fa-solid fa-phone"></i> +55 (41) 99246-4090
                  </p>
                  <p>
                    <a href="mailto:contato@jstudiodedanca.com.br" title="">
                      contato@jstudiodedanca.com.br
                    </a>
                  </p>
                </li>
                <li>
                  <h4>CONTATO</h4>
                  <p>Seg a Sex: 14:00 às 22:00</p>
                  <p>Sábado: 09:00 às 16:30</p>
                  <p>Feriados: Consultar Horários</p>
                </li>
                <li>
                  <h4>ENDEREÇO</h4>
                  <p>
                    Rua Augusto Stresser, 1745, Hugo Lange Curitiba, Paraná,
                    Brasil | CEP: 80.030-340
                  </p>
                  <p>
                    <a
                      href="https://www.google.com.br/maps/place/JS+Studio+de+Dan%C3%A7a/@-25.4175124,-49.2467646,17z/data=!3m1!4b1!4m5!3m4!1s0x94dce5e3361d4147:0xe33dfbddf1319b3!8m2!3d-25.4175173!4d-49.2445759"
                      title=""
                      className="btn-chegar"
                    >
                      Como Chegar
                    </a>
                  </p>
                </li>
              </ul>
            </div>

            <div className="box-links">
              <div className="menu">
                <ul>
                  <li>
                    <a
                      href="/politica-de-privacidade/"
                      title="Política de Privacidade"
                    >
                      POLÍTICA DE PRIVACIDADE
                    </a>
                  </li>
                  <li>
                    <a
                      href="/perguntas-frequentes/"
                      title="Perguntas Frequentes"
                    >
                      PERGUNTAS FREQUENTES
                    </a>
                  </li>
                  <li className="btn-msg">
                    <a
                      href="https://app.beeventz.com.br"
                      title="Sistema de Eventos JS Studio de Dança"
                    >
                      MINHA CONTA
                    </a>
                  </li>
                </ul>
              </div>
              <div className="redes-sociais">
                <ul>
                  <li>
                    <a
                      href="https://www.instagram.com/jsstudiodedanca/"
                      title="Instagram JS Studio de Dança"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.tiktok.com/@jsstudiodedanca"
                      title="Tik Tok JS Studio de Dança"
                    >
                      <i className="fa-brands fa-tiktok"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/JSStudiodeDanca/"
                      title="Facebook JS Studio de Dança"
                    >
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UC9pcKChidSY2reUlzG38f7A?view_as=subscriber"
                      title=""
                    >
                      <i className="fa-brands fa-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/jsstudiodedanca"
                      title="Linkedin JS Studio de Dança"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="copyright">
            <div className="box-txt">
              <p>
                © 2024 - JS Studio de Dança.{" "}
                <span className="direitos">Todos os Direitos Reservados.</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default FAQSection;
